<template>
  <div class="event-page">
    <NavHeaderBar :showSearch="false" :navBarTitle="$t('shared.event')" @backReturn="backReturn">
      <div class="right-header" @click="toUrl('/eventRecord')">
        <img class="icon-img" src="@/assets/images/map_time.png" alt="">
      </div>
    </NavHeaderBar>

    <!-- Filter Section (Sticky) -->
    <van-sticky :offset-top="46">
      <EventFilter
        ref="eventFilterRef"
        :product-options="globalData.brandProductList"
        :objKey="{label: 'productName', value: 'id'}"
        :type-options="typeOptions"
        selection-mode="multiple"
        @filter-change="onFilterChange"
      />
    </van-sticky>

    <!-- Event List -->
    <div class="list-container">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" :finished-text="$t('tips.noMoreData')" @load="onLoad">
          <div v-for="(item, index) in eventList" :key="index" class="event-card" @click="toUrl('/eventDetail', item)">
            <!-- Header: Title & Status Tag -->
            <div class="card-header">
              <div class="title-row">
                <span class="event-title txt-ellipsis">{{ item.eventType === 1 ? 'Pop Up' : item.eventType === 2 ? 'Brand Day' : '' }}-{{ item.policy.policyName }}</span>
                <span class="status-tag txt-ellipsis">{{ item.policy.modality === 0 ? $t('shared.onSite') : item.policy.modality === 1 ? $t('shared.offSite') : item.policy.modality === 2 ? $t('shared.webSite') : '' }}</span>
                <span class="by-status txt-ellipsis" v-if="item.policy.reportType">{{ item.policy.reportType === 1 ? $t('shared.byTime') : item.policy.reportType === 2 ? $t('shared.byDay') : '' }}</span>
              </div>
            </div>

            <!-- User Info -->
            <div class="info-row" v-if="item.createUserName">
              <img src="@/assets/images/map_user.png" class="row-icon" />
              <span class="info-text">{{ $t('shared.bA') }}: {{ item.createUserName }}</span>
            </div>

            <!-- Time Info & Status -->
            <div class="info-row">
              <img src="@/assets/images/map_time.png" class="row-icon" />
              <div class="time-content">
                <span v-if="![null, ''].includes(item.status)" class="time-status-badge" :class="{'status-not-started': item.status === 0, 'status-starting': item.status === 1, 'status-end': item.status === 2, 'status-archive': item.status === 10}">{{ item.status === 0 ? $t('shared.notStarted') : item.status === 1 ? $t('shared.startingNow') : item.status === 2 ? $t('shared.end') : item.status === 10 ? $t('shared.nonEditable') : '' }}</span>
                <span class="time-range">{{ item.startTime }} ~ {{ item.endTime }}</span>
              </div>
            </div>

            <!-- Tags -->
            <div class="info-row tags-row">
              <img src="@/assets/images/map_jian.png" class="row-icon" /> <!-- Placeholder icon if not exact -->
              <div class="tags-list">
                <span v-for="(tag, tIndex) in item.policy.policyProductList" :key="tIndex" class="product-tag" :style="{border: `1px solid ${tag.productColor}`, color: tag.productColor}">{{ tag.productName }}</span>
              </div>
            </div>

            <!-- Store Info -->
            <div class="info-row store-row">
              <img v-if="item.eventType === 2" src="@/assets/images/sd.png" class="row-icon" />
              <img v-else src="@/assets/images/store.png" class="row-icon" />
              <span class="store-name van-ellipsis">{{ item.targetName }}</span>
              <img src="@/assets/images/daohan1.png" class="nav-icon" @click.stop="getlocation(item)" />
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <!-- Bottom Button -->
    <div class="oper-btn">
      <van-button class="mapping-btn" type="info" @click="toUrl('/createEvent')">{{ $t('button.eventApplication') }}</van-button>
    </div>

  </div>
</template>

<script>
import { arsEventListPageApi } from '@/api/event'
import { Toast } from 'vant'
import { mapState, mapMutations } from 'vuex'
import EventFilter from './components/EventFilter'
export default {
  name: 'EventIndex',
  components: {
    EventFilter
  },
  data () {
    return {
      // List State
      eventList: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      limit: 10,

      // Filter State
      productIdList: [], // Changed to array for multiple selection support
      startTime: '',
      endTime: '',
      eventType: '',
      customerId: '',
      customerName: '',
      typeOptions: [
        { label: this.$t('form.popUp'), value: 1 },
        { label: this.$t('form.brandDay'), value: 2 }
      ],
      pageType: ''
    }
  },
  computed: {
    ...mapState({
      eventFilter: state => state.event.eventFilter,
      globalData: 'globalData'
    }),
    ...mapState('event', ['eventInfo', 'eventFilter'])
  },
  created () {
    this.pageType = this.$route.query.pageType || ''
    this.$nextTick(() => {
      if (['salesDistribution'].includes(this.pageType)) {
        this.$refs.eventFilterRef.echoData(2)
        this.eventType = 2
      }
    })
  },
  activated () {
    if (this.eventFilter) {
      this.productIdList = this.eventFilter.productIdList
      this.startTime = this.eventFilter.startTime
      this.endTime = this.eventFilter.endTime
      this.eventType = this.eventFilter.eventType
    }
    this.customerId = this.$route.query.customerId
    this.customerName = this.$route.query.customerName
    this.pageType = this.$route.query.pageType || ''
    // const needRefresh = sessionStorage.getItem('EVENT_LIST_NEED_REFRESH')
    // if (needRefresh) {
    //   sessionStorage.removeItem('EVENT_LIST_NEED_REFRESH')
    //   this.refreshing = true
    //   this.onRefresh()
    // }
    // 如果有筛选条件，重新加载数据
    if (this.eventType || this.productIdList.length > 0 || this.startTime) {
      this.onRefresh()
    }
  },
  // beforeRouteLeave (to, from, next) {
  //   console.log(to)
  //   const keepFilterPages = ['/eventDetail', '/createEvent', '/eventRecord']
  //   if (!keepFilterPages.some(path => to.path.includes(path))) {
  //     // 不是跳转到详情页，清空筛选
  //     this.resetFilter()
  //   }
  //   next()
  // },
  deactivated () {},
  methods: {
    ...mapMutations('event', ['SET_EVENTINFO', 'SET_EVENT_FILTER', 'CLEAR_EVENT_FILTER']),
    onFilterChange (data) {
      this.productIdList = data.product
      this.startTime = data.startDate
      this.endTime = data.endDate
      this.eventType = data.type
      // 保存到 Vuex
      this.SET_EVENT_FILTER({
        productIdList: this.productIdList,
        startTime: this.startTime,
        endTime: this.endTime,
        eventType: this.eventType
      })
      this.refreshing = true
      this.onRefresh()
    },
    // --- API & List Logic ---
    async onLoad () {
      if (this.refreshing) {
        this.eventList = []
        this.refreshing = false
      }

      if (this.page === 1) {
        this.eventList = []
      }

      try {
        const params = {
          page: this.page,
          limit: this.limit,
          // Add filter params here, map to actual API fields
          productIdList: this.productIdList,
          startTime: this.startTime,
          endTime: this.endTime,
          eventType: this.eventType,
          customerId: this.customerId
        }
        Toast.loading({
          message: this.$t('shared.loading'),
          forbidClick: true,
          duration: 0
        })
        const res = await arsEventListPageApi(params)
        Toast.clear()
        if (this.refreshing) {
          this.eventList = res.data.list
          this.refreshing = false
        } else {
          this.eventList = [...this.eventList, ...res.data.list]
        }

        this.page++
        if (this.eventList.length === Number(res.data.totalRow)) {
          this.finished = true
        }
      } catch (error) {
        console.error(error)
        this.finished = true
      } finally {
        this.loading = false
      }
    },
    onRefresh () {
      this.finished = false
      this.loading = true
      this.page = 1
      this.onLoad()
    },
    toUrl (url, params) {
      if (url === '/eventDetail') {
        this.$router.push(`${url}?eventId=${params.id}&pageType=${this.pageType}`)
        this.SET_EVENTINFO({ ...this.eventInfo, eventId: params.id })
      } else if (url === '/eventRecord') {
        this.$router.push(`${url}?customerId=${this.customerId ? this.customerId : ''}&pageType=${this.pageType}`)
        this.$destroy()
      } else if (url === '/createEvent') {
        let newUrl = `${url}?eventType=${this.pageType === 'salesDistribution' ? '2' : '1'}&pageType=${this.pageType ? this.pageType : ''}`
        if (this.customerId && this.customerName) {
          newUrl = `${url}?customerId=${this.customerId}&customerName=${this.customerName}&pageType=${this.pageType}`
        }
        this.$router.push(newUrl)
      } else {
        this.$router.push(url)
        // this.$destroy()
        this.$destroy()
      }
    },
    backReturn () {
      this.resetFilter()
      this.$destroy()
    },
    getlocation (params) {
      const currentTimeLoc =
        JSON.parse(window.localStorage.getItem('currentTimeLoc')) || {}
      // 根据经纬度获取位置
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      new google.maps.Geocoder().geocode(
        {
          location: new google.maps.LatLng(currentTimeLoc.lat, currentTimeLoc.lng)
        },
        function geoResults (results, status) {
          Toast.clear()
          // 这里处理结果和上面一模一样
          if (status === google.maps.GeocoderStatus.OK) {
            window.location.href = `https://www.google.com/maps/dir/?api=1&dir_action=navigate&origin=${results[0].formatted_address}&destination=${params.address}&waypoints=`
          } else {
            console.log('：error ' + status)
          }
        }
      )
    },
    resetFilter () {
      this.productIdList = []
      this.startTime = ''
      this.endTime = ''
      this.eventType = ''
      this.CLEAR_EVENT_FILTER()
    }
  }
}
</script>

<style lang="less" scoped>
.event-page {
  display: flex;
  flex-direction: column;
  background-color: #f7f8fa;
  height: 100%;

  .right-header {
    display: flex;
    align-items: center;
    margin-left: 10px;
    .icon-img {
      width: 20px;
      height: 20px;
    }
  }

  .list-container {
    flex: 1;
    overflow-y: auto;
  }

  .event-card {
    background: #fff;
    padding: 10px;
    border-bottom: 1px solid rgb(238, 229, 229);
    &:first-child {
      border-top: 1px solid rgb(238, 229, 229);
    }
    .card-header {
      margin-bottom: 8px;

      .title-row {
        display: flex;
        align-items: center;

        .event-title {
          max-width: 210px;
          font-size: 14px;
          font-weight: bold;
          color: #333;
          margin-right: 8px;
        }
        .status-tag {
          margin-right: 5px;
        }
        .status-tag,
        .by-status {
          max-width: 56px;
          font-size: 10px;
          padding: 2px 6px;
          border-radius: 2px;
          color: #fff;
          background-color: #f59a23;
        }
        .by-status {
          background-color: #c280ff;
        }
      }
    }

    .info-row {
      display: flex;
      margin-bottom: 6px;
      font-size: 13px;
      color: #666;
      line-height: 1.4;

      .row-icon {
        width: 13px;
        height: 13px;
        margin-right: 6px;
        object-fit: contain;
      }

      .info-text {
        flex: 1;
        font-size: 12px;
      }

      .time-content {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .time-status-badge {
          font-size: 10px;
          padding: 1px 4px;
          border-radius: 2px;
          margin-right: 6px;
          border: 1px solid currentColor;
          &.status-not-started {
            color: #d45648;
            background: #f7c9ce;
            border-color: #d45648;
          }
          &.status-starting {
            color: #1f9d16;
            background: #d2f6d1;
            border-color: #1f9d16;
          }
          &.status-end {
            color: #898989;
            background: #e6e6e6;
            border-color: #898989;
          }
          &.status-archive {
            color: #307bff;
            border-color: #307bff;
            background: #e9effc;
          }
        }

        .time-range {
          color: #666;
          font-size: 12px;
        }
      }
    }

    .tags-row {
      align-items: flex-start;
      .tags-list {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;

        .product-tag {
          font-size: 10px;
          padding: 1px 6px;
          border-radius: 2px;
          border: 1px solid;
        }
      }
    }

    .store-row {
      margin-bottom: 0;

      .store-name {
        flex: 1;
        font-size: 12px;
        color: #666;
      }

      .nav-icon {
        width: 16px;
        height: 16px;
        margin-left: 8px;
        color: #1989fa;
      }
    }
  }

  .oper-btn {
    width: 100%;
    .mapping-btn {
      width: 100%;
      background-color: #307bff;
      font-weight: bold;
      font-size: 16px;
    }
  }
}
</style>
